module.exports = __webpack_public_path__ + "img/ml.0fdff6d2.svg";